@if (getNumberOfPages() && showPagination) {
<div class="table-footer-container full-width letter-spacing-0 flex-row flex-start-center">
    <!--  Items Counter  -->
    <div
        class="items-counter"
        i18n
    >
        {{ RangeStart }}-{{ RangeEnd }} of {{ length }} items {selectedItemsCount, plural, =0 {} =1 {(one selected)} other {({{
            selectedItemsCount
        }}
        selected)}}
    </div>
    <div class="vertical-delimiter"></div>
    <!--  Items per Page Selector -->
    <div class="d-flex align-center">
        <span class="items-per-page-text">Items per page:</span>
        <mat-select
            [(value)]="itemsPerPage"
            [panelClass]="'items-per-page-selector'"
            class="items-per-page-selector"
            (selectionChange)="onItemsPerPageChange($event.value)"
        >
            @for (size of pageSizeOptions; track size) {
            <mat-option [value]="size">
                {{ size }}
            </mat-option>
            }
        </mat-select>
    </div>
    <div class="vertical-delimiter"></div>
    <!--  Go To First Page  -->
    <div>
        <button
            class="footer-icon-button navigation_keys"
            mat-icon-button
            [disabled]="currentDisplayedPage <= 1"
            (click)="firstPage(); currentDisplayedPage = 1"
        >
            <mat-icon>first_page</mat-icon>
        </button>
    </div>
    <div class="vertical-delimiter"></div>
    <!--  Go To Previous Page  -->
    <div>
        <button
            class="footer-icon-button fs-13"
            mat-icon-button
            [disabled]="currentDisplayedPage <= 1"
            (click)="onPreviousPageEvent()"
        >
            <mat-icon>chevron_left</mat-icon>
        </button>
    </div>
    <div class="vertical-delimiter"></div>
    <!--  Go To Next Page  -->
    <div class="f-s-13">
        <button
            class="footer-icon-button"
            mat-icon-button
            [disabled]="currentDisplayedPage >= getNumberOfPages()"
            (click)="onNextPageEvent()"
        >
            <mat-icon>chevron_right</mat-icon>
        </button>
    </div>
    <div class="vertical-delimiter"></div>
    <!--  Go To Last Page  -->
    <div>
        <button
            class="footer-icon-button"
            mat-icon-button
            [disabled]="currentDisplayedPage >= getNumberOfPages()"
            (click)="lastPage(); currentDisplayedPage = getNumberOfPages()"
        >
            <mat-icon>last_page</mat-icon>
        </button>
    </div>
    <div class="vertical-delimiter"></div>
    <!--  Current Page Selector  -->
    <div class="flex-row flex-start-center">
        <mat-select
            [(value)]="currentDisplayedPage"
            class="current-page-selector"
            panelClass="panel-page-selector"
            (selectionChange)="onCurrentPageChange($event.value)"
        >
            @for (pageNo of PageNumberOptions; track pageNo) {
            <mat-option [value]="pageNo">
                {{ pageNo }}
            </mat-option>
            }
        </mat-select>
        <span
            class="of-x-pages-text"
            i18n
        >
            of {{ getNumberOfPages() }} pages
        </span>
    </div>
    <span class="simple-spacer"></span>
</div>
}
